import { createFieldPolicy } from '@field-policy';

import { FINALIZE_POLICY_CONFIG } from './config';

/**
 * FinalizeBatch's field policy.
 *
 * The same instance `useFormPolicy` resolves at the call site - `createFieldPolicy` keys on the
 * `fields` object - so `usePolicyScope`'s identity assertion holds across both paths.
 */
export const finalizePolicy = createFieldPolicy(FINALIZE_POLICY_CONFIG);

export const { resolve: resolveField, resolveAll: resolveAllFields } = finalizePolicy;
